<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopicid: '',
        regrapiccliente: '',
        regrapicrede: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {
      dataFromApiTipoPicId: '',
      isLoading: false,
    };
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTipoPic();
    },
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
    async fetchDataFromTipoPic() {
      this.isLoading = true;
      try {
        const response = await axios.get('/tipo-pic');
        this.dataFromApiTipoPicId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.regrapiccliente === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Tipo PIC"
                label-for="tipopicid"
            >
            <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <div>
                  <b-form-select
                    v-model="dataForm.tipopicid"
                    id="tipopicid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiTipoPicId"
                    value-field="tipopicid"
                    text-field="tipopicdescricao"
                    placeholder="Digite o id"
                    :disabled="isLoading"
                  />
                  <small v-if="isLoading">
                    Carregando...
                  </small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Cliente"
                label-for="regrapiccliente"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.regrapiccliente"
                    id="regrapiccliente"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Rede"
                label-for="regrapicrede"
            >
              <validation-provider
                  #default="{ errors }"
                  name="regrapicrede"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.regrapicrede"
                    id="regrapicrede"
                    :state="errors.length > 0 ? false : null"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Familia Material"
                label-for="regrapicfamiliamaterial"
            >
              <validation-provider
                  #default="{ errors }"
                  name="regrapicfamiliamaterial"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.regrapicfamiliamaterial"
                    id="regrapicfamiliamaterial"
                    :state="errors.length > 0 ? false : null"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Grupo Representante"
                label-for="regrapicgruporepresentante"
            >
              <validation-provider
                  #default="{ errors }"
                  name="regrapicgruporepresentante"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.regrapicgruporepresentante"
                    id="regrapicgruporepresentante"
                    :state="errors.length > 0 ? false : null"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Unidade Negocio"
                label-for="regrapicunidadenegocio"
            >
              <validation-provider
                  #default="{ errors }"
                  name="regrapicunidadenegocio"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.regrapicunidadenegocio"
                    id="regrapicunidadenegocio"
                    :state="errors.length > 0 ? false : null"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
